export const UtcTimeZones: Record<string, number> = {
  hawaii: -10,
  alaska: -9,
  pacific: -8,
  mountain: -7,
  central: -6,
  eastern: -5,
  atlantic: -4,
} as const;

export type UtcTimeZones = (typeof UtcTimeZones)[keyof typeof UtcTimeZones];
